'use client';

import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import {
  IssuesPage_GetIssueDocument as GetIssueQuery,
  IssuesPage_IssueFragment,
} from '@/graphql';

export function useIssueData(
  issueId: string | null | undefined,
  currentEntityId: string | undefined,
  initialIssue: IssuesPage_IssueFragment | null | undefined,
) {
  const [issue, setIssue] = useState(initialIssue);

  const {
    data,
    loading: issueIsLoading,
    error,
    refetch,
  } = useQuery(GetIssueQuery, {
    variables: { id: issueId },
    fetchPolicy: 'network-only',
    skip: !issueId,
  });

  useEffect(() => {
    if (data?.issuesByPk) {
      setIssue(data.issuesByPk);
    }
  }, [data]);

  let isOwner = false;
  if (currentEntityId) {
    isOwner = issue?.leader?.id && issue.leader.id === currentEntityId;
  }

  const isActive = issue?.isActive;

  return {
    issue,
    isActive,
    isLoading: issueIsLoading,
    isOwner,
    error,
    refetch,
  };
}
